/** Vendor portal $10 account application fee — single source of truth for paid state. */
export const isAccountFeePaid = (userData) =>
  userData?.stripe_boho_paid === true ||
  userData?.store_payment_completed === true;
